import SwivlChatInterface from '../interface/SwivlChatInterface'
import { Message, isMessage,  Auth, isAuth, Frame, isFrame, ServerEnvironment} from '@swivl/swivl-lib'


import { browserName, browserVersion } from "react-device-detect";

import addressbar from  'addressbar'
import { AuthInterface } from '@swivl/swivl-lib/dist/types/models/Auth/AuthInterface';
import { Config } from '../Config/Config';
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export interface SocketHandlerInterface {

  delegate:SwivlChatInterface;

  // Socket Properties
  hasConnected:boolean; // Indicates if the websocket has connected or not.
  socket?:WebSocket;
  aliveInterval?:NodeJS.Timer;

  // Methods
  connect():void;
  sendMessage(message:Message):void;
}


export class SocketHandler implements SocketHandlerInterface {
  delegate: SwivlChatInterface;
  hasConnected: boolean = false;
  socket?: WebSocket | undefined;
  aliveInterval?: NodeJS.Timer | undefined;
  thirdPartyRetryCount = 0

  shouldStayClose = false;
  constructor(delegate:SwivlChatInterface) {
    this.delegate = delegate;
  }

  connect(): void {
    if (this.shouldStayClose) {
      console.warn("Should Stay Close mk1");
      
      return; 
    }
    if (Config.isReadOnly) {
      // this.delegate.onConnect() 
      console.warn("Read Only")
      return;
    }


    const auth = this.delegate.state.auth; 
    if (this.delegate.props.thirdPartyId &&
        (!auth || 
         !auth.thirdPartyId || auth.thirdPartyId !==  this.delegate.props.thirdPartyId )
         && this.thirdPartyRetryCount < 6
      ) {
        this.thirdPartyRetryCount++; 

        
        
        this.getThirdPartyIdAuth();
        return; 
      }

      try {
        if (this.delegate.props.webSocketServer) {

          this.socket = new WebSocket('wss://'+this.delegate.props.webSocketServer, "websocket");
        } else {
          this.socket = new WebSocket('wss://'+this.delegate.props.server, "websocket");
        }

        
    } catch(error) {
        console.warn('Error: Unable to connect.');
    }

    if (this.socket) {

      this.socket.onopen    = (event) => { this.socketOnOpen(event);    }
      this.socket.onmessage = (event) => { this.socketOnFrame(event); }
      this.socket.onerror   = (event) => { this.socketOnError(event);   }
      this.socket.onclose   = (event) => { this.socketOnClose(event);   }
    }

    this.aliveInterval = setInterval(() => {
      this.sendAliveMessage()
    }, 5000)
  }


  disconnect(): void {
    if (this.socket) {
      this.socket.close();
    }
    if (this.aliveInterval) {
      clearInterval(this.aliveInterval);
    }
    this.shouldStayClose = true;
    console.warn("did disconnect")
  }


    getThirdPartyIdAuth() {

      
      const url = 'https://'+this.delegate.props.server+'/bot_user/third_party_id?botId='+ Config.botId +'&thirdPartyId='+ this.delegate.props.thirdPartyId
      var req = new XMLHttpRequest();
    req.responseType = 'json';
    req.open('GET', url, true);
    var self = this;
    req.onload  = () => {
      var jsonResponse = req.response;
      // do something with jsonResponse

      if (isAuth(jsonResponse)) {
        self.delegate.updateAuth(jsonResponse as AuthInterface)
        self.connect();
      }
      };
      req.onerror = () => {
        setTimeout(() => {
          self.connect();
        }, 500);
      }
req.send(null);  
}


  socketOnOpen(_: Event): void {

    
    if (!this.hasConnected) {   this.delegate.onConnect()  }
    this.hasConnected = true;

  }

  socketOnFrame(e: MessageEvent): void {

    let data: Message;
    try {
      data = JSON.parse(e.data);
    } catch(error) {
      console.warn('Error: Unable to parse JSON.');
      return;
    }

    
    this.delegate.messageHandler.handleMessage(data);

  }

  socketOnError(e: Event): void { 
    console.warn("Socket Error", e); 
      if (this.socket) { this.socket.close();  } }
  socketOnClose(e: Event): void {
    
    console.warn("Socket Closed"); 
  const rando = getRandomInt(3,15)

  setTimeout(() => { 
    this.connect(); 
  },  rando * 1000);

}

  sendAliveMessage(): void {
      /* NOTE:
      This really should be done over a web socket. 
      Either throught the main web socket or a seperate one.
      Doing requests is messy and slow I <think className="
      */ 
      if (!this.delegate.props.isOpen) { return; }

      if (this.delegate.props.transcriptOnly) { return; }
      if (this.delegate.state.auth && !this.delegate.props.canTakeOver && this.socket && this.socket.readyState == 1) {
      if (this.delegate.state.auth.botUserId && this.delegate.state.auth.botId) {

        const notificationsServer =  (this.delegate.props.notificationsServer) ? this.delegate.props.notificationsServer : "notifications.swivl.studio";
        const environment = (this.delegate.props.environment) ? `?environment=${this.delegate.props.environment}` : "";
        var xhr = new XMLHttpRequest();
        const url = `https://${notificationsServer}/active/${this.delegate.state.auth.botId}/bot_user/${this.delegate.state.auth.botUserId}${environment}`;
        xhr.open("POST", url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({}));
      }
    }
  }



  sendMessage(message:Message) {
   if(this.delegate.props.transcriptOnly) { return; }

    let frame:Frame = {message:message}

    if (addressbar && addressbar.origin) {
      frame.address =  {
                        origin: addressbar.origin,
                        port: addressbar.port,
                        protocol: addressbar.protocol,
                        hostname:addressbar.hostname,
                        pathname:addressbar.pathname,
                        hash:addressbar.hash,
                        isMobile:this.delegate.props.isMobile
                        }
        frame.browser = `${browserName} ${browserVersion}`

      } else {

        
      }

    if (this.delegate.state.auth && isAuth(this.delegate.state.auth)) {
      frame.auth = this.delegate.state.auth;
    }
    if (frame.auth && this.delegate.props.thirdPartyId) { frame.auth.thirdPartyId = this.delegate.props.thirdPartyId}
    if (isFrame(frame)) {
      this.socket?.send(JSON.stringify(frame));
      if (this.delegate.props.onMessageSent) {
        this.delegate.props.onMessageSent(message);
      }
    } else {
      console.warn("Invalid Frame", frame);
    }
  }


}
